import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import SEO from "../components/SEO";

const Home = () => {
  return (
    <Layout>
      <SEO
        path="/"
        title="Lancers Studio — Expert. Expertise. Experience."
        description="On-demand technical experts and flexible workforce solutions for the facade and construction industry in India. Consulting deployment and outsourced project execution."
      />
      <section
        className="relative min-h-[calc(100vh-72px)] flex items-center justify-center px-5 sm:px-8 pt-16 pb-24"
        data-testid="hero-section"
      >
        {/* Background glow accents */}
        <div
          className="ls-glow"
          style={{ top: "-120px", left: "50%", transform: "translateX(-50%)" }}
        />
        <div
          className="ls-glow"
          style={{
            bottom: "-180px",
            left: "10%",
            width: 360,
            height: 360,
            opacity: 0.5,
          }}
        />

        <div className="relative max-w-5xl w-full text-center ls-fade-up">
          {/* Logo */}
          <div
            className="relative mx-auto mb-12 flex items-center justify-center"
            style={{ width: 320, maxWidth: "85vw" }}
            data-testid="logo-placeholder"
          >
            <div
              className="ls-glow"
              style={{
                width: 520,
                height: 520,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                opacity: 1,
              }}
            />
            <img
              src="/logo.png"
              alt="Lancers Studio"
              className="relative"
              style={{
                width: 320,
                maxWidth: "85vw",
                height: "auto",
                objectFit: "contain",
                filter: "drop-shadow(0 0 30px rgba(243, 215, 137, 0.35))",
              }}
              onError={(e) => {
                // Fallback: render gold-bordered placeholder card if logo.png missing.
                const node = e.currentTarget;
                const parent = node.parentNode;
                if (!parent || parent.querySelector("[data-fallback-hero]")) return;
                node.style.display = "none";
                const card = document.createElement("div");
                card.setAttribute("data-fallback-hero", "true");
                card.className = "relative ls-card flex items-center justify-center";
                card.style.width = "100%";
                card.style.aspectRatio = "1 / 1";
                card.style.maxWidth = "320px";
                card.style.borderRadius = "28px";
                card.innerHTML =
                  '<div class="text-center px-6">' +
                  '<div class="font-cinzel gold-text font-extrabold" style="font-size:5.4rem;line-height:1;letter-spacing:0.08em;">LS</div>' +
                  '<div class="mt-3 text-[0.65rem] uppercase tracking-[0.32em]" style="color:#8a8a8a;">Logo Placeholder</div>' +
                  "</div>";
                parent.appendChild(card);
              }}
            />
          </div>

          {/* Tagline */}
          <h1
            className="font-cinzel uppercase font-bold leading-tight"
            style={{
              fontSize: "clamp(1.8rem, 4.2vw, 3.4rem)",
              letterSpacing: "0.12em",
              color: "#f5f5f5",
            }}
            data-testid="hero-tagline"
          >
            <span>
              <span style={{ color: "var(--ls-red)" }}>EX</span>PERT.
            </span>{" "}
            <span>
              <span style={{ color: "var(--ls-red)" }}>EX</span>PERTISE.
            </span>{" "}
            <span>
              <span style={{ color: "var(--ls-red)" }}>EX</span>PERIENCE.
            </span>
          </h1>

          <p
            className="mt-7 max-w-2xl mx-auto text-base sm:text-lg leading-relaxed"
            style={{ color: "var(--ls-muted)" }}
            data-testid="hero-subtext"
          >
            On-demand technical experts and flexible workforce solutions for
            companies that need speed, skill, and dependable execution.
          </p>

          {/* CTAs */}
          <div
            className="mt-10 flex flex-col sm:flex-row gap-4 items-center justify-center"
            data-testid="hero-ctas"
          >
            <Link
              to="/consulting"
              className="ls-btn-gold"
              data-testid="cta-consulting"
            >
              <span>Lancers Consulting</span>
            </Link>
            <Link
              to="/services"
              className="ls-btn-gold"
              data-testid="cta-services"
            >
              <span>Lancers Services</span>
            </Link>
          </div>

          {/* Frosted info card */}
          <div
            className="ls-card mt-14 mx-auto max-w-3xl px-7 sm:px-9 py-7 text-left sm:text-center"
            data-testid="hero-info-card"
          >
            <p
              className="text-[0.95rem] sm:text-base leading-relaxed"
              style={{ color: "var(--ls-muted)" }}
            >
              We support businesses with{" "}
              <span style={{ color: "#f5f5f5" }}>expert resources</span>,{" "}
              <span style={{ color: "#f5f5f5" }}>technical capability</span>,
              and <span style={{ color: "#f5f5f5" }}>ready-to-deploy teams</span>.
              Whether you need consulting support or project-based service
              execution, <span className="gold-text font-medium">Lancers Studio</span>{" "}
              helps you move faster.
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Home;
